var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 336V496H496V336H16Z",
    fill: "#2ECC71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 176V336H496V176H16Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16V176H496V16H16Z",
    fill: "#2980B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M255.391 187.811C253.249 187.857 251.159 190.229 251.159 190.229L251.344 215.576L243.341 223.96H249.82L249.765 238.495L211.442 290.1L205.777 288.142L195.875 309.265C195.875 309.265 220.366 324.601 255.913 324.181C294.929 323.717 316.125 308.558 316.125 308.558L305.893 287.707L300.883 289.886L262.069 238.55L262.014 223.581H268.492L259.675 215.301L259.727 190.047C259.727 190.047 257.533 187.767 255.391 187.813L255.391 187.811Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M268.758 248.495H242.258C242.258 248.495 232.64 228.231 234.199 214.063C235.787 199.638 244.031 192.813 254.993 192.693C267.952 192.548 274.745 199.043 276.797 213.486C278.83 227.797 268.758 248.497 268.758 248.497L268.758 248.495Z",
    stroke: "black",
    strokeWidth: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M209.077 296.801C208.644 297.378 205.467 303.732 205.467 303.732L210.954 302.577L209.077 296.801V296.801Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M212.246 305.032L206.47 306.909L213.402 309.653L212.246 305.032H212.246Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M214.852 296.939L217.74 305.459L224.815 303.437L222.938 299.394L214.852 296.939Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M219.324 308.502L220.335 311.967L229.721 314.278L225.967 306.336L219.324 308.502H219.324Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M229.722 301.273L233.043 309.215L240.119 306.472L237.808 303.006L229.722 301.273Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M234.345 312.11L235.5 315.142L246.474 316.731L241.853 309.511L234.345 312.11V312.11Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M244.88 303.591L248.924 310.666L259.176 306.912L258.021 304.168L244.88 303.591V303.591Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M250.806 313.262L252.972 317.016L265.679 316.583L260.914 309.508L250.806 313.262H250.806Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M264.236 303.88L267.701 309.8L275.787 305.901L273.621 302.725L264.236 303.88V303.88Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M277.515 308.352L269.428 312.395L271.594 315.86L282.424 314.127L277.515 308.352V308.352Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M280.12 302.138L284.308 307.337L291.095 301.994L288.784 299.539L280.12 302.138Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M292.535 304.882L286.037 309.791L287.77 312.824L296.723 310.513L292.535 304.882H292.535Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M301.492 294.634L303.081 296.944L298.604 303.586L293.984 297.666L301.492 294.634Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M304.524 300.409L307.268 305.896L301.781 307.773L301.347 305.174L304.524 300.409V300.409Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLs);
export default __webpack_public_path__ + "static/media/LS.732c6938c8f383ffb5412458c0b3abcf.svg";
export { ForwardRef as ReactComponent };